import {useEffect, useRef} from "react";
import Consts from "../core/consts";

const TOUCHES_REQUIRED = 8

function useSevenTapDetector(onSevenTaps, maxDelay = 300) {
    const tapCount = useRef(0);
    const lastTapTime = useRef(0);
    const timeoutRef = useRef(null);

    const handleTouchStart = () => {


        const now = Date.now();

        if (now - lastTapTime.current <= maxDelay) {
            tapCount.current += 1;
        } else {
            tapCount.current = 1;
        }

        lastTapTime.current = now;

        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            tapCount.current = 0;
        }, maxDelay);

        if (tapCount.current === TOUCHES_REQUIRED) {
            tapCount.current = 0;
            clearTimeout(timeoutRef.current);
            onSevenTaps();
        }
    };

    return {onTouchStart: handleTouchStart};
}

export function AmsKioskConfigurator({tag_ID}) {
    const {onTouchStart} = useSevenTapDetector(() => {
        if (window.prompt("Gib den Code für den Zugriff ein?") === "626466") {
            const tUrl = window.prompt("Checkout URL")

            if (tUrl !== null) {
                const terminalID = window.prompt("Terminal ID")
                localStorage.setItem("checkout_URL", tUrl)
                localStorage.setItem("terminal_ID", terminalID)
                if (!tUrl) {
                    window.location.href = `/benutzer/login`
                } else {
                    window.location.href = Consts.f(`/checkout/${tUrl.split("/")[4]}`,tUrl)
                }
            }
        }
    });
    useEffect(() => {
        const tUrl = localStorage.getItem("checkout_URL")
        if (!!tUrl) {
            const tID = tUrl.split("/")[4];
            if (parseInt(tID) !== parseInt(tag_ID)) {
                window.location.href = Consts.f(`/checkout/${tUrl.split("/")[4]}`,tUrl)
            }
        }

        window.addEventListener("click", onTouchStart);
        window.addEventListener("touchstart", onTouchStart);
    }, [])
    return null
}